import { styled } from 'styled-components';
import { useParams } from 'react-router-dom';
import { trackEvent } from 'lib/amplitude';
import DashboardMenu from './DashboardMenu';
import OrgMenu from './OrgMenu';
import HelpLink from './HelpLink';
import { Tooltip } from './ui';

const Wrapper = styled.nav.attrs({
  id: 'top-nav',
  'aria-label': 'dashboards and help',
})`
  display: flex;
  background-color: #273d56;
  height: 44px;
  align-items: center;
  padding: 0 4px;
  justify-content: space-between;
`;

const LogoIcon = styled.img.attrs({
  width: 24,
  height: 24,
  type: 'image/svg+xml',
  src: '/logo.svg',
  alt: 'UrbanFootprint Logo',
})`
  margin: 0 9px 0 8px;
`;

const LogoWrapper = styled.a`
  display: flex;
  cursor: pointer;

  &[data-state='disabled'] {
    cursor: default;
  }
`;

const NavSection = styled.div`
  display: flex;
  align-items: center;
`;

const TooltipHeader = styled.header`
  color: #fff;
  font-weight: 600;
  padding-bottom: 4px;
`;

/**
 * shared UI page header, should look like Analyst
 *
 * @param {object} props -
 * @param {Array} props.projects - array of projects
 * @param {object} props.active - active id, name, and project
 * @param {string} props.orgKey - organization key
 * @param {Array} props.portfolios - array of portfolios with organizations
 * @param {object} props.organization - organization info
 */
export default function TopBar({
  projects,
  active,
  orgKey,
  portfolios,
  organization,
}) {
  const { projectKey } = useParams();
  // Use the active project key, if dashboard is loaded, else the route param (no dashboards)
  const activeProjectKey = active?.project?.key || projectKey;
  const link = activeProjectKey
    ? `${import.meta.env.UF_APP_ORIGIN}/explore/${orgKey}/project/${activeProjectKey}?maponly=1`
    : null;
  return (
    <Wrapper>
      <NavSection>
        <LogoWrapper
          data-state={link ? '' : 'disabled'}
          onClick={(e) => {
            e.preventDefault();
            trackEvent('UF Logo Clicked - Return to Analyst', {
              orgKey,
              projectKey: activeProjectKey,
            });
            window.location.assign(link);
          }}
        >
          <LogoIcon />
        </LogoWrapper>
        <DashboardMenu
          projects={projects}
          activeId={active?.id}
          activeName={active?.name}
          activeProject={active?.project?.name}
          orgKey={orgKey}
        />
      </NavSection>
      <NavSection>
        <HelpLink
          url={organization?.help_url}
          dashboardId={active?.id}
          dashboardName={active?.name}
        />
        <Tooltip
          content={
            <>
              <TooltipHeader>{organization?.name}</TooltipHeader>
              in &ldquo;{organization?.portfolio}&rdquo;
            </>
          }
        >
          <OrgMenu orgKey={orgKey} portfolios={portfolios} />
        </Tooltip>
      </NavSection>
    </Wrapper>
  );
}
